import { defineMessages } from "react-intl";

export default defineMessages({
    pageTitle: {
        id: "pages__dashboard-page__page-title",
        defaultMessage: "Dashboard",
    },
});
